import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import {
  Col,
  Row,
  ControlLabel
} from 'react-bootstrap';
import SuperSelectComponent from './SuperSelectComponent';

const owners = {
  NONE: 'none',
  GROUPS: 'groups',
  HUNTERS: 'hunters'
};

export default class ArtifactsMetricsHunterSelectorComponent extends React.Component {
  static propTypes = {
    artifactsInfo: PropTypes.shape(
      {
        inGroups: PropTypes.bool.isRequired,
        groups: PropTypes.arrayOf(PropTypes.string).isRequired,
        hunters: PropTypes.arrayOf(PropTypes.string).isRequired,
      }
    ),
    availableGroups: PropTypes.array.isRequired,
    availableHunters: PropTypes.array.isRequired,
    onSelectorChange: PropTypes.func.isRequired
  };

  huntersGetGroup = (hunter) => hunter.slice(0, hunter.indexOf('.'));

  render() {
    const {
      availableGroups,
      availableHunters,
      artifactsInfo,
      onSelectorChange
    } = this.props;

    const initialState = {
      selectOwner: owners.NONE,
      inGroups: true,
      groups: artifactsInfo.groups,
      hunters: artifactsInfo.hunters
    };

    return (
      <div>
        <fieldset>
          <h3> Filters </h3>
          <LocalForm
            id="artifacts-selector-form"
            initialState={initialState}
            onChange={model => onSelectorChange(model)}
          >
            <Row>
              <Col md={3}>
                <ControlLabel> Timings By Artifact </ControlLabel>
                <Control.custom
                  id="hunter-category-select"
                  model="."
                  component={SuperSelectComponent}
                  style={{ marginLeft: '10px' }}
                  className="form-control"
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      options: availableGroups,
                      initialValues: modelValue.groups,
                      onOpenDropdown: () => onChange({
                        ...modelValue,
                        selectOwner: owners.GROUPS
                      }),
                      onCloseDropDown: () => onChange({
                        ...modelValue,
                        selectOwner: owners.NONE
                      }),
                      onChange: (selected) => {
                        if (modelValue.selectOwner !== owners.GROUPS) {
                          return;
                        }
                        const model = {
                          ...modelValue,
                          inGroups: true,
                          groups: selected,
                          hunters: []
                        };
                        return onChange(model);
                      }
                    };
                  }}
                  multiple
                  selectAll
                  keepOpenOnSelection
                  closeOnSelectedOptionClick={false}
                  searchable
                  selectedCountDisplay
                />
              </Col>
              <Col md={1}>
                <h4 align="center">OR</h4>
              </Col>
              <Col md={3}>
                <ControlLabel> Timings By Hunter </ControlLabel>
                <Control.custom
                  id="hunter-select"
                  model="."
                  component={SuperSelectComponent}
                  style={{ marginLeft: '10px' }}
                  className="form-control"
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      options: availableHunters,
                      initialValues: modelValue.hunters,
                      getGroup: this.huntersGetGroup,
                      onOpenDropdown: () => onChange({
                        ...modelValue,
                        selectOwner: owners.HUNTERS
                      }),
                      onCloseDropDown: () => onChange({
                        ...modelValue,
                        selectOwner: owners.NONE
                      }),
                      onChange: (selected) => {
                        if (modelValue.selectOwner !== owners.HUNTERS) {
                          return;
                        }
                        const model = {
                          ...modelValue,
                          inGroups: false,
                          groups: [],
                          hunters: selected
                        };
                        return onChange(model);
                      }
                    };
                  }}
                  grouped
                  multiple
                  keepOpenOnSelection
                  closeOnSelectedOptionClick={false}
                  searchable
                  selectedCountDisplay
                />
              </Col>
            </Row>
          </LocalForm>
        </fieldset>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/ArtifactsMetricsHunterSelectorComponent.jsx